import { render } from "./addChaptersModal.vue?vue&type=template&id=4bec85e5&scoped=true"
import script from "./addChaptersModal.vue?vue&type=script&lang=js"
export * from "./addChaptersModal.vue?vue&type=script&lang=js"

import "./addChaptersModal.vue?vue&type=style&index=0&id=4bec85e5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bec85e5"]])

export default __exports__